import { render, staticRenderFns } from "./NoticeListElement.vue?vue&type=template&id=5cbaf974&scoped=true&lang=pug&"
import script from "./NoticeListElement.vue?vue&type=script&lang=ts&"
export * from "./NoticeListElement.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeListElement.vue?vue&type=style&index=0&id=5cbaf974&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbaf974",
  null
  
)

export default component.exports